import React, { useEffect, useMemo, useState, useRef } from "react";
import { toUrlExcursionVendor } from "../../../helper/vendorMask";
import { useNavigate } from "react-router";
import "../../../assets/css/Excursion.css";
import { ChevronDownIcon, ChevronRightIcon, ChevronUpIcon, SearchIcon } from "../../../helper/HwIcon";
import imag1 from '../../../assets/img/excursion-banner-img.jpg'
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { ChevronLeftIcon } from "../../../helper/HwIconExcursion";
import HwSelect from "../../../component/HwSelect";
import HwDatePicker from "../../../component/HwDatePicker";
import { useSelector } from "react-redux";
import { formatePriceFn, formatPrice } from "../../../helper/commonFunction";
import { getRecentSearch } from "./getRecentSearch";
import { useCityStaticData } from "./useCityStaticData";
import { useAllCities, cityNameToSlug } from "./useAllCities";
import cityPlaceholderImg from "../../../assets/img/no-image-holder.png";
import moment from "moment";
import {
    dummyFaqs
} from "./excursionDummyData";

const bestCityIds = [13668, 13236, 14644, 16424, 15533, 23726];

const ExcursionSearch = () => {
    const { agentActiveCurrency, displayPrice } = useSelector((state) => state.userData);
    const navigate = useNavigate();
    const [activeIndex, setActiveIndex] = useState(null);
    const [selectedDest, setSelectedDest] = useState(null);
    const [travelDate, setTravelDate] = useState(null);
    const [searchErrors, setSearchErrors] = useState({ dest: "", date: "" });
    const [destKeyword, setDestKeyword] = useState("");

    const {
        cities: apiCities,
        loading: citiesLoading,
        searchResults: citySearchResults,
        searching: citySearching,
        searchCities,
    } = useCityStaticData();

    const destinationOptions =
        destKeyword.trim().length >= 2
            ? citySearchResults ?? []
            : apiCities.length > 0
                ? apiCities
                : [];


    const { cities: allCities, loading: allCitiesLoading } = useAllCities();

    const bestCities = bestCityIds
        .map((id) => allCities.find((c) => c?.cityId === id))
        .filter(Boolean);

    const {
        data: popularData,
        loading: popularLoading,
        getSearch,
        search: trackRecentExcursion,
    } = getRecentSearch();

    useEffect(() => {
        getSearch().catch(() => null);
    }, []);

    const popularSearches =
        Array.isArray(popularData) && popularData.length > 0
            ? popularData
            : Array.isArray(popularData?.data) && popularData.data.length > 0
                ? popularData.data
                : [];

    const citiesSliderRef = useRef(null);
    const [canCitiesPrev, setCanCitiesPrev] = useState(false);
    const [canCitiesNext, setCanCitiesNext] = useState(true);
    const [citiesInView, setCitiesInView] = useState(false);
    const cityDragInfo = useRef({ dragged: false });

    useEffect(() => {
        const el = citiesSliderRef.current;
        if (!el) return;
        let isDown = false;
        let startX = 0;
        let startScroll = 0;

        const onPointerDown = (e) => {
            isDown = true;
            cityDragInfo.current.dragged = false;
            startX = e.pageX;
            startScroll = el.scrollLeft;
        };
        const onPointerMove = (e) => {
            if (!isDown) return;
            const dx = e.pageX - startX;
            if (Math.abs(dx) > 5 && !cityDragInfo.current.dragged) {
                cityDragInfo.current.dragged = true;
                el.classList.add("dragging");
                el.style.scrollBehavior = "auto";
            }
            if (cityDragInfo.current.dragged) {
                el.scrollLeft = startScroll - dx;
            }
        };
        const onPointerUp = () => {
            isDown = false;
            el.classList.remove("dragging");
            el.style.scrollBehavior = "smooth";
        };

        el.addEventListener("pointerdown", onPointerDown);
        window.addEventListener("pointermove", onPointerMove);
        window.addEventListener("pointerup", onPointerUp);
        return () => {
            el.removeEventListener("pointerdown", onPointerDown);
            window.removeEventListener("pointermove", onPointerMove);
            window.removeEventListener("pointerup", onPointerUp);
        };
    }, []);

    const words = ["Dubai", "Ras Al Khaimah", "Abu Dhabi", "Singapore", "Phuket"];
    const [wordIndex, setWordIndex] = useState(0);
    const [currentText, setCurrentText] = useState("");
    const [isDeleting, setIsDeleting] = useState(false);
    const [typingSpeed, setTypingSpeed] = useState(150);

    useEffect(() => {
        const handleType = () => {
            const currentWord = words[wordIndex];
            if (!isDeleting) {
                setCurrentText(currentWord.substring(0, currentText.length + 1));
                if (currentText === currentWord) {
                    setTypingSpeed(1500);
                    setIsDeleting(true);
                } else {
                    setTypingSpeed(100);
                }
            } else {
                setCurrentText(currentWord.substring(0, currentText.length - 1));
                if (currentText === "") {
                    setIsDeleting(false);
                    setWordIndex((prev) => (prev + 1) % words.length);
                    setTypingSpeed(500);
                } else {
                    setTypingSpeed(50);
                }
            }
        };

        const timer = setTimeout(handleType, typingSpeed);
        return () => clearTimeout(timer);
    }, [currentText, isDeleting, wordIndex, typingSpeed]);

    const updateCitiesNavigation = () => {
        const slider = citiesSliderRef.current;
        if (!slider) {
            setCanCitiesPrev(false);
            setCanCitiesNext(false);
            return;
        }
        const scrollLeft = slider.scrollLeft;
        const scrollWidth = slider.scrollWidth;
        const clientWidth = slider.clientWidth;
        const scrollRight = scrollWidth - scrollLeft - clientWidth;
        const hasOverflow = scrollWidth > clientWidth + 2;

        setCanCitiesPrev(hasOverflow && scrollLeft > 5);
        setCanCitiesNext(hasOverflow && scrollRight > 5);
    };

    const scrollCitiesLeft = () => {
        if (citiesSliderRef.current) {
            const scrollAmount = citiesSliderRef.current.clientWidth * 0.8;
            citiesSliderRef.current.scrollBy({
                left: -scrollAmount,
                behavior: 'smooth'
            });
        }
    };

    const scrollCitiesRight = () => {
        if (citiesSliderRef.current) {
            const scrollAmount = citiesSliderRef.current.clientWidth * 0.8;
            citiesSliderRef.current.scrollBy({
                left: scrollAmount,
                behavior: 'smooth'
            });
        }
    };

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            updateCitiesNavigation();
        }, 100);
        return () => clearTimeout(timer);
    }, [allCitiesLoading]);

    useEffect(() => {
        const el = citiesSliderRef.current;
        if (!el) return;
        if (!('IntersectionObserver' in window)) {
            setCitiesInView(true);
            return;
        }
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setCitiesInView(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.2 }
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    const handleSearchClick = () => {
        const errors = {
            dest: !selectedDest ? "Please select a destination" : "",
            date: !travelDate ? "Please select a travel date" : "",
        };
        if (errors.dest || errors.date) {
            setSearchErrors(errors);
            return;
        }
        setSearchErrors({ dest: "", date: "" });

        const params = new URLSearchParams({
            city: selectedDest.value,
            "city-id": selectedDest.cityId ?? "",
            "country-id": selectedDest.countryId ?? "",
            "travel-date": moment(travelDate).format("DD-MM-YYYY"),
        });

        navigate(`/excursion/list?${params.toString()}`, {
            state: {
                destinationValue: selectedDest.value,
                travelDate: travelDate.toISOString(),
            },
        });
    };

    useEffect(() => {
        window.scrollTo(0, 0);

        const timer = setTimeout(() => {
            updateCitiesNavigation();
        }, 100);

        const citiesSlider = citiesSliderRef.current;

        const handleResize = () => {
            setTimeout(() => {
                updateCitiesNavigation();
            }, 100);
        };

        if (citiesSlider) {
            citiesSlider.addEventListener('scroll', updateCitiesNavigation);
        }

        window.addEventListener('resize', handleResize);

        return () => {
            clearTimeout(timer);
            if (citiesSlider) {
                citiesSlider.removeEventListener('scroll', updateCitiesNavigation);
            }
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <>
            <div className="hw-top--fixImg hw-excursion-banner-img">
                <img src={imag1} alt="" />
                <div className="hw-excursion-banner-overlay"></div>
            </div>

            <div className="hw-widget hw-excursion--mainSearch">
                <div className="hw-page--width">
                    <div className="hw-widget--card" style={{ background: "transparent", minHeight: "436px", justifyContent: "center" }}>
                        <h1 className="hw-excursion-banner-title single-line">
                            Discover the best things to do in <span className="typewriter-text">{currentText}</span>
                        </h1>

                        <div className="hw-excursion-search-widget">
                            <div className="hw-excursion-search-col">
                                <label>Where to?</label>
                                {citiesLoading ? (
                                    <Skeleton
                                        containerClassName="hw-excursion-search-skeleton"
                                        height="100%"
                                        borderRadius={4}
                                    />
                                ) : (
                                    <HwSelect
                                        placeholder="Select Destination"
                                        options={destinationOptions}
                                        onChangeFn={(val) => {
                                            setSelectedDest(val);
                                            setSearchErrors((prev) => ({ ...prev, dest: "" }));
                                        }}
                                        value={selectedDest}
                                        type="excursion-dest"
                                        width="100%"
                                        isError={!!searchErrors.dest}
                                        loading={citySearching}
                                        inputValue={destKeyword}
                                        menuChnageFn={() => null}
                                        onInputChangeFn={(val) => {
                                            setDestKeyword(val ?? "");
                                            searchCities(val);
                                        }}
                                    />
                                )}
                                {searchErrors.dest && (
                                    <span className="hw-excursion-search-error">{searchErrors.dest}</span>
                                )}
                            </div>

                            <div className="hw-excursion-search-col hw-excursion-search-col-date">
                                <label>Travel Date</label>
                                <HwDatePicker
                                    selectDate={travelDate}
                                    onChangeFn={(date) => {
                                        setTravelDate(date);
                                        setSearchErrors((prev) => ({ ...prev, date: "" }));
                                    }}
                                    type="Select Date"
                                    renderType="excursion"
                                    selectAfterShow={false}
                                    isError={searchErrors.date ? true : false}
                                    wrapperClassName="hw-excursion-search-datepicker"
                                />
                                {searchErrors.date && (
                                    <span className="hw-excursion-search-error">{searchErrors.date}</span>
                                )}
                            </div>

                            <div className="hw-excursion-search-col hw-excursion-search-col-btn">
                                <label style={{ opacity: 0, pointerEvents: 'none' }}>Search</label>
                                <button className="hw-excursion-search-btn" onClick={handleSearchClick}>
                                    <SearchIcon />
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {(popularLoading || popularSearches.length > 0) && (
            <div className="hw-page--width pt-48">
                <div className="hw-faq--accordion">
                    <div className="hw-box--gridWhite">
                        <div className="hw-excursion-section-header">
                            <div>
                                <h2 className="hw-excursion-section-title">Popular Searches</h2>
                            </div>
                        </div>
                        {popularLoading ? (
                            <div className="row">
                                {[1, 2, 3, 4].map((i) => (
                                    <div className="col-sm-6 col-xl-3" key={i}>
                                        <Skeleton height="150px" width={"100%"} />
                                        <Skeleton height="20px" width={"100%"} count={3} />
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="row">
                                {popularSearches.map((d) => {
                                    const hasInstantConfirmation =
                                        d?.instantConfirmation === true || d?.instantConfirmation === "Yes";
                                    return (
                                        <div className="col-sm-6 col-xl-3" key={d?.excursionId}>
                                            <div className="hw-book--filterResultGrid">
                                                <a
                                                    className="whole-link"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        trackRecentExcursion(d?.excursionId).catch(() => null);
                                                        const detailParams = new URLSearchParams({
                                                            vendor: toUrlExcursionVendor(d?.vendor ?? "DahrTours"),
                                                            "tour-id": d?.tourId ?? "",
                                                            "contract-id": d?.contractId ?? "",
                                                            "country-id": d?.countryId ?? "",
                                                            "city-id": d?.cityId ?? "",
                                                            "travel-date": "",
                                                        });
                                                        navigate(`/excursion/details/${d?.excursionId}?${detailParams.toString()}`);
                                                    }}
                                                    href="#"
                                                ></a>
                                                <div className="image-box">
                                                    <img src={d?.excursionThumbnail} alt={d?.excursionTitle} width="300" />
                                                </div>
                                                <div className="content-box">
                                                    <div className="hw-text12">{d?.excursionCatagories?.[0]?.taxonomyName}</div>
                                                    <div className="hw-ticket--title">{d?.excursionTitle}</div>
                                                    <div className="content-box--inner" style={!hasInstantConfirmation ? { flexWrap: "nowrap" } : {}}>
                                                        <div className="price">
                                                            <small>From</small>
                                                            {formatePriceFn(agentActiveCurrency, formatPrice(d?.excursionPrice?.adultPrice, false, false, true), displayPrice)}
                                                        </div>
                                                        {hasInstantConfirmation && <div className="tick-list">Instant Confirmation</div>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            )}

            <div className="hw-page--width pt-48">
                <div className="hw-excursion-section-header">
                    <div>
                        <h2 className="hw-excursion-section-title">Best Cities to Visit</h2>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
                        <a onClick={(e) => { e.preventDefault(); navigate(`/excursion/cities`); }} href="#" style={{ fontSize: '1.4rem', fontWeight: '500', color: 'var(--hw-brand-orange)', textDecoration: 'underline' }}>View all</a>
                        <div style={{ display: 'flex', gap: '0.8rem' }}>
                            <button
                                className="hw-excursion-slider-nav-btn prev"
                                style={{ position: 'relative', left: 0, right: 0 }}
                                onClick={scrollCitiesLeft}
                                disabled={!canCitiesPrev}
                            >
                                <ChevronLeftIcon />
                            </button>
                            <button
                                className="hw-excursion-slider-nav-btn next"
                                style={{ position: 'relative', left: 0, right: 0 }}
                                onClick={scrollCitiesRight}
                                disabled={!canCitiesNext}
                            >
                                <ChevronRightIcon />
                            </button>
                        </div>
                    </div>
                </div>

                <div className="hw-excursion-slider-container">
                    <div
                        ref={citiesSliderRef}
                        className={`hw-excursion-card-slider hw-city-slider${citiesInView ? ' in-view' : ''}`}
                        style={{
                            display: 'flex',
                            gap: '2.5rem',
                            overflowX: 'auto',
                            scrollBehavior: 'smooth',
                            scrollbarWidth: 'none',
                            msOverflowStyle: 'none',
                            WebkitOverflowScrolling: 'touch',
                            paddingBottom: '1rem'
                        }}
                    >
                        {allCitiesLoading
                            ? [1, 2, 3, 4].map((i) => (
                                <div key={i} style={{ flex: '0 0 25rem' }}>
                                    <Skeleton height="30rem" width="100%" borderRadius="1.6rem" />
                                </div>
                            ))
                            : bestCities.map((city, index) => (
                                <div
                                    key={city.cityId}
                                    className="hw-city-card"
                                    style={{ flex: '0 0 25rem', animationDelay: `${index * 90}ms` }}
                                    onClick={() => {
                                        if (cityDragInfo.current.dragged) {
                                            cityDragInfo.current.dragged = false;
                                            return;
                                        }
                                        const params = new URLSearchParams({
                                            city: cityNameToSlug(city.cityName),
                                            "city-id": city.cityId ?? "",
                                            "country-id": city.countryId ?? "",
                                        });
                                        navigate(`/excursion/list?${params.toString()}`, {
                                            state: {
                                                selectedCategory: { catId: 'all', catName: 'All Activities' },
                                                destinationValue: city.cityId,
                                            },
                                        });
                                    }}
                                >
                                    <div className="hw-city-card-media">
                                        <img src={city.cityImage || cityPlaceholderImg} alt={city.cityName} className="hw-city-card-img" />
                                        <div className="hw-city-card-overlay"></div>
                                    </div>
                                    <div className="hw-city-card-content">
                                        <p className="hw-city-card-subtitle">{city.countryName}</p>
                                        <h3 className="hw-city-card-title">Things to do in {city.cityName}</h3>
                                        <div className="hw-city-card-cta">
                                            <span className="hw-city-card-cta-label">Explore activities</span>
                                            <span className="hw-city-card-arrow">
                                                <ChevronRightIcon />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>

            <div className="hw-page--width pt-48 pb-48">
                <div className="hw-box--gridWhite">
                    <div className="hw-head--textWrap">
                        <h2 className="h3 hw-black900">Excursion FAQs</h2>
                    </div>

                    <div className="hw-flight--faq">
                        {dummyFaqs.map((faq, index) => (
                            <div className="hw-faq--item" key={index}>
                                <div className="hw-faq--title"
                                    onClick={() => toggleAccordion(index)}
                                    style={{ color: activeIndex === index ? 'var(--hw-brand-blue)' : 'var(--hw-black-900)' }}
                                >
                                    <span>{index + 1}.&nbsp;&nbsp;{faq.question}</span>
                                    <span className="svg-wrapper">
                                        {activeIndex === index ? <ChevronUpIcon /> : <ChevronDownIcon />}
                                    </span>
                                </div>
                                {activeIndex === index && (
                                    <div className="hw-faq--desc">
                                        <p dangerouslySetInnerHTML={{ __html: faq.description }} />
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ExcursionSearch;
